import { ChangeDetectionStrategy, Component, Optional } from '@angular/core';
import { DialogRef } from '@progress/kendo-angular-dialog';

@Component({
    selector: 'app-whats-new',
    templateUrl: './whats-new.component.html',
    styleUrl: './whats-new.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class WhatsNewComponent {

    constructor(@Optional() public dialogRef: DialogRef) {}

    public close(): void {
        this.dialogRef?.close();
    }
}
